import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: "",
  isData: false,
};

const pdfData = createSlice({
  name: "pdfDoc",
  initialState,

  reducers: {
    addData: (state, action) => {
      state.data = action.payload;
      state.isData = true;
    },
    removeData: (state) => {
      state.data = null;
      state.isData = false;
    },
  },
});

export const { addData, removeData } = pdfData.actions;

export default pdfData.reducer;
